'use client';

import type { FC, ReactNode } from 'react';
import { cn } from '../../utils/cn';

const PANEL_BACKGROUND =
  'linear-gradient(180deg, rgba(15,18,30,0.95) 0%, rgba(10,12,20,0.98) 100%)';

interface DesktopSidebarPanelProps {
  width: number;
  className?: string;
  children: ReactNode;
}

export const DesktopSidebarPanel: FC<DesktopSidebarPanelProps> = ({
  width,
  className,
  children,
}) => (
  <div className="shrink-0 sticky top-6 self-start" style={{ width }}>
    <div
      className={cn('rounded-2xl border border-white/[0.06]', className)}
      style={{ background: PANEL_BACKGROUND }}
    >
      {children}
    </div>
  </div>
);
